import { useEffect, useMemo } from 'react';

import { AxiosQueryModel, useSeedrsClient } from '@r-client/shared/data/client';

export type UnknownRecord = Record<string, unknown>;

export interface IBusinessRowData {
  id: number;
  name: string;
  logo: string;
  performance: string;
  valuation: string;
}

export interface IEUBusinessesQueryVariables {
  per_page?: number;
  page?: number;
  page_size?: number;
  funded?: boolean;
  sort?: 'performance_desc';
}

export type APIResponse<T> = {
  result: T;
  meta?: unknown;
};

export class EUBusinessesQuery extends AxiosQueryModel<
  APIResponse<UnknownRecord[]>,
  IEUBusinessesQueryVariables
> {
  protected query() {
    return this.client.get<APIResponse<UnknownRecord[]>>('/businesses', {
      params: {
        per_page: this.variables?.per_page ?? 10,
        page: this.variables?.page ?? 1,
        page_size: this.variables?.page_size ?? 10,
        funded: this.variables?.funded ?? true,
        sort: this.variables?.sort ?? 'performance_desc',
      },
    });
  }
}

export const useEuropeBusinessesQuery = (
  variables: IEUBusinessesQueryVariables
) => {
  const client = useSeedrsClient();

  const data = useMemo(() => {
    return new EUBusinessesQuery({
      variables: {
        per_page: variables.per_page,
        page: variables.page,
        page_size: variables.page_size,
        funded: variables.funded,
        sort: variables.sort,
      },
      client,
    });
  }, [
    client,
    variables.per_page,
    variables.page,
    variables.page_size,
    variables.funded,
    variables.sort,
  ]);

  useEffect(() => {
    if (!data) return;

    data.fetch();
  }, [data]);

  return data;
};
